import { Box, Container, Typography } from "@mui/material";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import commitmentBg from "../../assets/images/a_c_bg.png";
import commitmentBgm from "../../assets/images/a_c_bg_m.png";
import cardBg from "../../assets/images/services_showcase_bg.png";

const commitments = [
  "Premium Fabric Care",
  "Eco-Friendly Cleaning",
  "Quality Inspected",
  "On-Time Delivery",
  "Experienced Team",
  "Customer First Service",
];

export default function OurCommitment() {
  return (
    <Box
      sx={{
        py: {
          xs: 4,
          md: 6,
        },

        position: "relative",

        overflow: "hidden",

        backgroundImage: {
          xs: `url(${commitmentBgm})`,
          md: `
          url(${commitmentBg})
        `,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",

        backgroundRepeat: "no-repeat",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            maxWidth: {
              xs: "100%",
              lg: "700px",
            },
          }}
        >
          {/* Badge */}

          <Box
            sx={{
              display: "inline-flex",

              px: 2.5,

              py: 1,

              borderRadius: "50px",

              background: "rgba(0,87,255,.08)",

              color: "#0057FF",

              fontSize: "12px",

              fontWeight: 800,

              letterSpacing: "1px",

              textTransform: "uppercase",
            }}
          >
            Our Commitment
          </Box>

          {/* Heading */}

          <Typography
            sx={{
              mt: 2,

              fontWeight: 900,

              lineHeight: 1.05,

              color: "#07122F",

              fontSize: {
                xs: "32px",
                sm: "32px",
                md: "56px",
                lg: "56px",
              },
            }}
          >
            Exceptional Care
            <br />
            <Box
              component="span"
              sx={{
                background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                WebkitBackgroundClip: "text",

                WebkitTextFillColor: "transparent",
              }}
            >
              Every Step Of The Way
            </Box>
          </Typography>

          {/* Description */}

          <Typography
            sx={{
              mt: 3,

              maxWidth: "620px",

              color: "#64748B",

              lineHeight: 1.9,

              fontSize: {
                xs: "13px",
                sm: "14px",
                md: "16px",
              },
            }}
          >
            At Comet Cleaners, every garment receives expert attention from
            pickup to delivery. Our commitment to quality, reliability and
            customer satisfaction ensures your clothing looks its absolute best.
          </Typography>

          {/* Feature Cards */}

          <Box
            sx={{
              mt: 5,

              display: "flex",

              flexWrap: "wrap",

              gap: 1.5,
            }}
          >
            {commitments.map((item, index) => (
              <Box
                key={index}
                sx={{
                  flex: {
                    xs: "0 0 calc(50% - 6px)", // 2 cards per row mobile
                    md: "1 1 calc(50% - 8px)", // 2 cards per row desktop
                  },

                  maxWidth: {
                    xs: "calc(50% - 6px)",
                    md: "calc(50% - 8px)",
                  },

                  //   minHeight: {
                  //     xs: 90,
                  //     md: 100,
                  //   },

                  p: {
                    xs: 1.3,
                    md: 2,
                  },

                  borderRadius: "16px",

                  backgroundImage: `
    
      url(${cardBg})
    `,

                  backgroundSize: "cover",

                  backgroundPosition: "bottom",

                  border: "1px solid rgba(255,255,255,.85)",

                  boxShadow: "0 10px 25px rgba(0,87,255,.08)",

                  display: "flex",

                  alignItems: "center",

                  gap: {
                    xs: 1,
                    md: 1.5,
                  },

                  transition: ".3s",

                  "&:hover": {
                    transform: "translateY(-4px)",

                    boxShadow: "0 20px 45px rgba(0,87,255,.12)",
                  },
                }}
              >
                <CheckCircleIcon
                  sx={{
                    color: "#0057FF",

                    fontSize: 24,
                  }}
                />

                <Typography
                  sx={{
                    color: "#12305F",

                    fontWeight: 700,

                    fontSize: {
                      xs: "14px",
                      md: "15px",
                    },
                  }}
                >
                  {item}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Stats Card */}

          <Box
            sx={{
              mt: 5,

              display: "inline-flex",

              flexDirection: "column",

              p: {
                xs: 2.5,
                md: 3,
              },

              borderRadius: "26px",

              background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

              color: "#fff",

              boxShadow: "0 25px 60px rgba(0,87,255,.25)",
            }}
          >
            <Typography
              sx={{
                fontWeight: 900,

                lineHeight: 1,

                fontSize: {
                  xs: "42px",
                  md: "56px",
                },
                color: "#fff",
              }}
            >
              1000+
            </Typography>

            <Typography
              sx={{
                mt: 1,

                fontWeight: 600,

                fontSize: {
                  xs: "15px",
                  md: "16px",
                },
                color: "#fff",
              }}
            >
              Happy Customers Served
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
